import { Formik, Form as FormikForm, Field as FormikField } from 'formik'
import { SMSCodeValidationScheme } from '@/shared'
import styles from '../VerificationSms.module.scss'
import { Button, Field } from '@/ui'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { userSelectors, userThunks } from '@/entity'
import { verificationActions } from '@/entity/verification'
import { VERIFICATION_STEPS_NAME } from '@/entity/verification/constants'

export const Step3 = ({onSuccess}) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const {iin} = useSelector(state => ({
		iin: state.verification.iin,
	}))

	const user = useSelector(userSelectors.user)

	const handleSave = (data) => {
		let body = {
			data: {
				payload: { confirmCode: data?.code, iin: iin.data?.iin },
				user: user
			},
			onSuccess: (res) => {
				onSuccess()
			},
			onError: (e) => {
				dispatch(verificationActions.setStepName(VERIFICATION_STEPS_NAME.error))
			},
		}
		dispatch(userThunks.verificationSms(body))
	}

	return (
		<Formik initialValues={{ code: '' }} validationSchema={SMSCodeValidationScheme} onSubmit={handleSave}>
			{({ values, isValid }) => {
				return (
					<FormikForm>
						<div className={'flex'}>
							<div className={styles.fields}>
								<FormikField name={'code'}>
									{({ field, meta: { touched, error } }) => (
										<Field
											hideNumberArrows
											label={t('code_bmg')}
											placeholder={t('code_bmg_placeholder', { count: 6 })}
											error={touched && error}
											{...field}
											maxLength={6}
											pattern="[0-9]{6}"
										/>
									)}
								</FormikField>
							</div>
							<div className={styles.fieldAndButton}>
								<Button disabled={!isValid} type="submit">
									{t('send')}
								</Button>
							</div>
						</div>
					</FormikForm>
				)
			}}
		</Formik>
	)
}